import ImpactInfoTooltip from "./ImpactInfoTooltip";

interface ImpactMetricCardProps {
  label: string;
  value: string;
  description: string;
  definition: string;
}

export default function ImpactMetricCard({
  label,
  value,
  description,
  definition,
}: ImpactMetricCardProps) {
  return (
    <article className="impact-metric-card">
      <div className="impact-metric-card__heading">
        <p className="impact-metric-card__label">{label}</p>
        <ImpactInfoTooltip label={label} definition={definition} />
      </div>
      <strong className="impact-metric-card__value">{value}</strong>
      <p className="impact-metric-card__description">{description}</p>
    </article>
  );
}
